import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';

export interface IServiceSupervisorEmailNotificationPreferencesValidated {
    sendNotificationEmployment: boolean;
    sendNotificationEmploymentAlt: boolean;
    sendNotificationPractitioner: boolean;
}

const serviceSupervisorEmailNotificationPreferences = Koi.object().keys({
    sendNotificationEmployment: Koi.boolean(),
    sendNotificationEmploymentAlt: Koi.boolean(),
    sendNotificationPractitioner: Koi.boolean(),
});

// eslint-disable-next-line @stylistic/max-len
export const serviceSupervisorEmailNotificationPreferencesSchema: ISchemaContainer<IServiceSupervisorEmailNotificationPreferencesValidated> =
    {
        schema: serviceSupervisorEmailNotificationPreferences.options({ convert: false, presence: 'required' }),
    };

export interface IServiceSupervisorAddEditValidated extends IServiceSupervisorEmailNotificationPreferencesValidated {
    compensationPayOut: number | null;
    employmentId: string;
    endDate: string | null;
    serviceId: string;
    startDate: string;
}

const serviceSupervisorAddEdit = Koi.object()
    .keys({
        compensationPayOut: Koi.number().min(0).precision(0).allow(null),
        employmentId: Koi.string().uuid(),
        endDate: Koi.koi().date().allow(null),
        serviceId: Koi.string().uuid(),
        startDate: Koi.koi().date(),
    })
    .concat(serviceSupervisorEmailNotificationPreferences);

export const serviceSupervisorAddEditSchema: ISchemaContainer<IServiceSupervisorAddEditValidated> = {
    schema: serviceSupervisorAddEdit.options({ convert: false, presence: 'required' }),
};
